module.exports = __webpack_public_path__ + "media/wolf.e410542b.wav";